

import axios from "axios";
import { ElMessage } from "element-plus";
import router from "../router"

// create an axios instance
const service = axios.create({
  baseURL: BASE_URL, // api的base_url
  timeout: -1, // 请求超时时间
  headers: {
    "content-type": "application/json;charset=UTF-8",
  },
  withCredentials: true,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // 从 localStorage 中获取参数
    const customParam = localStorage.getItem('token');
    if (customParam) {
      // 在请求头中添加参数
      config.headers['Authorization'] = customParam;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


service.interceptors.response.use(
  (response) => {
    //返回因有ResponeType===Blob ,分开处理
    if (Object.prototype.toString.call(response.data).indexOf("Blob") > -1) {
      let reader = new FileReader()
      reader.onload = function (e) {
        {
          try {
            let str = this.result.toString();
            let res = JSON.parse(str);
            if (res.code != null) {
              if (res.code !== 200) {
                ElMessage.error(res.msg);
              }
            }

          } catch { }
        }
      }
      reader.readAsText(response.data, "utf-8");
    } else {
      if (response.data.code !== 200) {

        ElMessage.error(response.data.msg);
        if (response.data.code === 401) {
          router.push('/login');
        }

      }
    }// 报错提示
    return response.data;
  },
  (error) => {

    if (error.response != null) {
      const { status, data } = error.response;
      //返回因有ResponeType===Blob ,分开处理
      if (Object.prototype.toString.call(data).indexOf("Blob") > -1) {
        let reader = new FileReader()
        reader.onload = function (e) {
          {
            let str = this.result.toString();
            let res = JSON.parse(str);

            ElMessage({
              message: res.message,
              type: "error",
              duration: 5 * 1000,
            });
          }
        }
        reader.readAsText(data, "utf-8");

      } else {

        ElMessage({
          message: data.message,
          type: "error",
          duration: 5 * 1000,
        });
      }
    } else {

      ElMessage({
        message: error.message,
        type: "error",
        duration: 5 * 1000,
      });
    }
    return Promise.reject(error);
  }
);


export default service;
